import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonCircle,
} from '@/components/common/skeleton';

interface Props {
  numColumns?: number;
}

const GRID_GAP = 16;
const TILE_COUNT = 6;

export const DesktopResourcesViewSkeleton: React.FC<Props> = ({ numColumns = 3 }) => {
  const tileWidth = `${Math.floor(100 / numColumns) - 2}%` as `${number}%`;

  return (
    <SkeletonGroup>
      <View style={styles.grid}>
        {Array.from({ length: TILE_COUNT }).map((_, i) => (
          <View key={i} style={[styles.tile, { flexBasis: tileWidth }]}>
            <SkeletonCard borderRadius={16} padding={20}>
              <SkeletonCircle size={40} />
              <SkeletonBone width="70%" height={16} />
              <SkeletonBone width="50%" height={14} />
            </SkeletonCard>
          </View>
        ))}
      </View>
    </SkeletonGroup>
  );
};

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: GRID_GAP,
  },
  tile: {
    flexGrow: 1,
  },
});
